/**
 * @generated SignedSource<<09b627d8267104a651f029453a18a6d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type APPROVAL_STATUS = "APPROVED" | "SUBMITTED" | "NOT_SUBMITTED" | "%future added value";
export type FILTER_SECTION = "PROJECT" | "SCOPING" | "SPRINT" | "SPRINT_BACKLOG" | "WORKFLOW" | "SCHEDULING_PEOPLE" | "SCHEDULING_PROJECTS" | "SCHEDULING_PLACEHOLDERS" | "SCHEDULING_CAPACITY_OVERVIEW" | "MY_TASKS" | "MY_LIST" | "MY_WORK" | "MY_TIMESHEETS" | "PROJECTS_OVERVIEW" | "INVOICING_OVERVIEW" | "INVOICING_INVOICES" | "FINANCIAL_PORTFOLIO_REPORT" | "TEAM_TIMESHEET" | "TIME_APPROVAL" | "REPORTED_TIME_TABLE" | "PROJECT_TIMELINE" | "UTILIZATION_REPORT" | "TASK_REPORT" | "SKILLS" | "LABELS" | "%future added value";
export type LANGUAGE = "ENGLISH_US" | "ENGLISH_UK" | "ENGLISH_EU" | "SPANISH" | "DANISH" | "POLISH" | "FRENCH" | "%future added value";
export type PROGRAM_BUDGET_TYPE = "UNCAPPED" | "CAPPED" | "FIXED_PRICE" | "%future added value";
export type PROJECT_STATUS = "OPPORTUNITY" | "PLANNING" | "RUNNING" | "HALTED" | "DONE" | "%future added value";
export type STATUS_CATEGORY = "TODO" | "INPROGRESS" | "DONE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type TimesheetsPage_viewer$data = {
  readonly id: string;
  readonly harvestUser: boolean | null;
  readonly unit4User: boolean | null;
  readonly actualPersonId: string | null;
  readonly email: string | null;
  readonly backendId: number | null;
  readonly language: LANGUAGE | null;
  readonly availableFeatureFlags: ReadonlyArray<{
    readonly key: string | null;
  } | null> | null;
  readonly filters: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly section: FILTER_SECTION | null;
        readonly value: string | null;
        readonly updatedAt: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly calendarIntegrations: {
    readonly googleCalendar: {
      readonly calendarTokenError: string | null;
      readonly calendarFetchEnabled: boolean | null;
      readonly enabledCalendars: ReadonlyArray<string | null> | null;
    } | null;
    readonly outlookCalendar: {
      readonly calendarTokenError: string | null;
      readonly calendarFetchEnabled: boolean | null;
      readonly enabledCalendars: ReadonlyArray<string | null> | null;
    } | null;
  } | null;
  readonly company: {
    readonly id: string;
    readonly useTimeApproval: boolean | null;
    readonly useInternalTimeApproval: boolean | null;
    readonly useTimeOffApproval: boolean | null;
    readonly harvestEnabled: boolean | null;
    readonly bambooHREnabled: boolean | null;
    readonly hiBobEnabled: boolean | null;
    readonly sageIntacctEnabled: boolean | null;
    readonly unit4Enabled: boolean | null;
    readonly characterLimit: number | null;
    readonly lockedPeriodYear: number | null;
    readonly lockedPeriodMonth: number | null;
    readonly lockedPeriodDay: number | null;
    readonly roles: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
        } | null;
      } | null> | null;
    } | null;
    readonly modules: ReadonlyArray<{
      readonly moduleType: string | null;
    } | null> | null;
    readonly internalTimes: {
      readonly totalCount: number | null;
    } | null;
    readonly idleTimes: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
          readonly isInternalTime: boolean | null;
          readonly favoured: boolean | null;
          readonly disabled: boolean | null;
        } | null;
      } | null> | null;
    } | null;
    readonly person: {
      readonly holidayCalendar: {
        readonly id: string;
        readonly holidayCalendarEntries: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly day: number | null;
              readonly month: number | null;
              readonly year: number | null;
              readonly name: string | null;
            } | null;
          } | null> | null;
        } | null;
        readonly name: string | null;
      } | null;
      readonly id: string;
      readonly role: {
        readonly id: string;
        readonly name: string | null;
      } | null;
      readonly firstName: string | null;
      readonly lastName: string | null;
      readonly fullName: string | null;
      readonly createdAt: string | null;
      readonly startDate: string | null;
      readonly endDate: string | null;
      readonly systemUser: boolean | null;
      readonly initials: string | null;
      readonly active: boolean | null;
      readonly monday: number | null;
      readonly tuesday: number | null;
      readonly wednesday: number | null;
      readonly thursday: number | null;
      readonly friday: number | null;
      readonly saturday: number | null;
      readonly sunday: number | null;
      readonly excludeFromCompanyLockedPeriod: boolean | null;
      readonly submitLockedDateYear: number | null;
      readonly submitLockedDateMonth: number | null;
      readonly submitLockedDateDay: number | null;
      readonly harvestUser: boolean | null;
      readonly unit4User: boolean | null;
      readonly economicUser: boolean | null;
      readonly profilePictureId: string | null;
      readonly profilePictureDefaultId: number | null;
      readonly email: string | null;
    } | null;
    readonly customFieldDefinitionsV2?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly key: string;
          readonly type: string;
          readonly displayName: string;
          readonly entityType: string;
          readonly readOnly?: boolean;
          readonly options?: ReadonlyArray<{
            readonly id: string;
            readonly displayName: string;
          }>;
        } | null;
      } | null> | null;
    } | null;
  } | null;
  readonly projects: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly fullAccessToProject: boolean | null;
        readonly companyProjectId: number | null;
        readonly status: PROJECT_STATUS | null;
        readonly billable: boolean | null;
        readonly projectColor: string | null;
        readonly projectStartYear: number | null;
        readonly projectStartMonth: number | null;
        readonly projectStartDay: number | null;
        readonly projectEndYear: number | null;
        readonly projectEndMonth: number | null;
        readonly projectEndDay: number | null;
        readonly manualProgressOnProjectEnabled: boolean | null;
        readonly manualProgressOnPhasesEnabled: boolean | null;
        readonly manualProgressOnTasksEnabled: boolean | null;
        readonly projectPerson: {
          readonly role: {
            readonly id: string;
            readonly name: string | null;
          } | null;
        } | null;
        readonly harvestProject: {
          readonly id: string;
        } | null;
        readonly unit4Project: {
          readonly id: string;
          readonly activitiesEnabled: boolean | null;
        } | null;
        readonly isJiraProject: boolean | null;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"ProjectDropdown_projects">;
    } | null> | null;
  } | null;
  readonly timeRegistrations: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly day: number | null;
        readonly month: number | null;
        readonly year: number | null;
        readonly minutesRegistered: number | null;
        readonly billableMinutesRegistered: number | null;
        readonly updatedAt: string | null;
        readonly role: {
          readonly id: string;
          readonly name: string | null;
        } | null;
        readonly notes: string | null;
        readonly invoiced: boolean | null;
        readonly xeroInvoiceId: string | null;
        readonly lockedInPeriod: boolean | null;
        readonly harvestTimeId: number | null;
        readonly allocationId: string | null;
        readonly harvestTaskIdInt: number | null;
        readonly harvestError: string | null;
        readonly unit4ActivityId: string | null;
        readonly approvalStatus: APPROVAL_STATUS | null;
        readonly hiBobAllocationId: string | null;
        readonly project: {
          readonly id: string;
          readonly name: string | null;
          readonly status: PROJECT_STATUS | null;
          readonly projectColor: string | null;
          readonly companyProjectId: number | null;
          readonly estimationUnit: string | null;
          readonly fullAccessToProject: boolean | null;
          readonly isProgramRevenueLocked: boolean | null;
          readonly programBudgetType: PROGRAM_BUDGET_TYPE | null;
          readonly program: {
            readonly name: string | null;
            readonly prefix: string | null;
            readonly budgetType: PROGRAM_BUDGET_TYPE | null;
            readonly members: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly role: string | null;
                  readonly person: {
                    readonly id: string;
                  } | null;
                } | null;
              } | null> | null;
            } | null;
          } | null;
          readonly billable: boolean | null;
          readonly projectStartYear: number | null;
          readonly projectStartMonth: number | null;
          readonly projectStartDay: number | null;
          readonly projectEndYear: number | null;
          readonly projectEndMonth: number | null;
          readonly projectEndDay: number | null;
          readonly manualProgressOnProjectEnabled: boolean | null;
          readonly manualProgressOnPhasesEnabled: boolean | null;
          readonly manualProgressOnTasksEnabled: boolean | null;
          readonly projectPerson: {
            readonly role: {
              readonly id: string;
              readonly name: string | null;
            } | null;
          } | null;
          readonly harvestProject: {
            readonly id: string;
            readonly name: string | null;
          } | null;
          readonly unit4Project: {
            readonly id: string;
            readonly name: string | null;
            readonly activitiesEnabled: boolean | null;
          } | null;
          readonly client: {
            readonly id: string;
            readonly name: string;
          } | null;
          readonly customProjectId: string | null;
        } | null;
        readonly task: {
          readonly id: string;
          readonly name: string | null;
          readonly progress: number | null;
          readonly companyTaskId: number | null;
          readonly jiraId: string | null;
          readonly highPriority: boolean | null;
          readonly approved: boolean | null;
          readonly timeLeft: number | null;
          readonly favoured: boolean | null;
          readonly fullAccessToProject: boolean | null;
          readonly latestUiUpdateAt: string | null;
          readonly estimateForecastMinutes: number | null;
          readonly totalMinutesRegistered: number | null;
          readonly billable: boolean | null;
          readonly parentTaskId: string | null;
          readonly parentTask: {
            readonly name: string | null;
            readonly companyTaskId: number | null;
          } | null;
          readonly startYear: number | null;
          readonly startMonth: number | null;
          readonly startDay: number | null;
          readonly deadlineYear: number | null;
          readonly deadlineMonth: number | null;
          readonly deadlineDay: number | null;
          readonly statusColumnV2: {
            readonly category: STATUS_CATEGORY | null;
          } | null;
          readonly assignedPersons: ReadonlyArray<{
            readonly id: string;
          } | null> | null;
          readonly project: {
            readonly id: string;
            readonly name: string | null;
            readonly status: PROJECT_STATUS | null;
            readonly companyProjectId: number | null;
            readonly isProgramRevenueLocked: boolean | null;
            readonly programBudgetType: PROGRAM_BUDGET_TYPE | null;
            readonly program: {
              readonly name: string | null;
              readonly prefix: string | null;
              readonly budgetType: PROGRAM_BUDGET_TYPE | null;
              readonly members: {
                readonly edges: ReadonlyArray<{
                  readonly node: {
                    readonly role: string | null;
                    readonly person: {
                      readonly id: string;
                    } | null;
                  } | null;
                } | null> | null;
              } | null;
            } | null;
            readonly billable: boolean | null;
            readonly projectColor: string | null;
            readonly estimationUnit: string | null;
            readonly fullAccessToProject: boolean | null;
            readonly projectStartYear: number | null;
            readonly projectStartMonth: number | null;
            readonly projectStartDay: number | null;
            readonly projectEndYear: number | null;
            readonly projectEndMonth: number | null;
            readonly projectEndDay: number | null;
            readonly manualProgressOnProjectEnabled: boolean | null;
            readonly manualProgressOnPhasesEnabled: boolean | null;
            readonly manualProgressOnTasksEnabled: boolean | null;
            readonly projectPerson: {
              readonly role: {
                readonly id: string;
                readonly name: string | null;
              } | null;
            } | null;
            readonly client: {
              readonly id: string;
              readonly name: string;
            } | null;
            readonly harvestProject: {
              readonly id: string;
              readonly name: string | null;
            } | null;
            readonly unit4Project: {
              readonly id: string;
              readonly name: string | null;
              readonly activitiesEnabled: boolean | null;
            } | null;
            readonly customProjectId: string | null;
          } | null;
          readonly phase: {
            readonly id: string;
            readonly name: string | null;
          } | null;
        } | null;
        readonly idleTime: {
          readonly id: string;
          readonly name: string | null;
          readonly isInternalTime: boolean | null;
          readonly favoured: boolean | null;
          readonly disabled: boolean | null;
        } | null;
        readonly person: {
          readonly id: string;
          readonly firstName: string | null;
          readonly lastName: string | null;
          readonly isViewer: boolean | null;
          readonly role: {
            readonly id: string;
            readonly name: string | null;
          } | null;
        } | null;
        readonly customFields: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly __typename: string;
              readonly key: string;
              readonly displayName: string;
              readonly value: string | null;
              readonly displayValue: string | null;
              readonly readOnly?: boolean;
              readonly options?: ReadonlyArray<{
                readonly id: string;
                readonly displayName: string;
              } | null>;
            } | null;
          } | null> | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "TimesheetsPage_viewer";
};
export type TimesheetsPage_viewer$key = {
  readonly " $data"?: TimesheetsPage_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimesheetsPage_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "harvestUser",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unit4User",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "calendarTokenError",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "calendarFetchEnabled",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "enabledCalendars",
    "storageKey": null
  }
],
v12 = [
  (v0/*: any*/),
  (v5/*: any*/)
],
v13 = {
  "kind": "Literal",
  "name": "first",
  "value": 100000
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "favoured",
  "storageKey": null
},
v15 = [
  (v0/*: any*/),
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isInternalTime",
    "storageKey": null
  },
  (v14/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "disabled",
    "storageKey": null
  }
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "day",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v23 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "readOnly",
    "storageKey": null
  }
],
v24 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomFieldDropdownOption",
    "kind": "LinkedField",
    "name": "options",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      (v22/*: any*/)
    ],
    "storageKey": null
  }
],
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullAccessToProject",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartYear",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartMonth",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectStartDay",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndYear",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndMonth",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectEndDay",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnProjectEnabled",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnPhasesEnabled",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "manualProgressOnTasksEnabled",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "personId",
      "variableName": "personId"
    }
  ],
  "concreteType": "ProjectPerson",
  "kind": "LinkedField",
  "name": "projectPerson",
  "plural": false,
  "selections": [
    (v19/*: any*/)
  ],
  "storageKey": null
},
v40 = [
  (v0/*: any*/)
],
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activitiesEnabled",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "estimationUnit",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isProgramRevenueLocked",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "programBudgetType",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "ProgramType",
  "kind": "LinkedField",
  "name": "program",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prefix",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "budgetType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectServiceProgramMemberTypeConnection",
      "kind": "LinkedField",
      "name": "members",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectServiceProgramMemberTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectServiceProgramMemberType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "role",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Person",
                  "kind": "LinkedField",
                  "name": "person",
                  "plural": false,
                  "selections": (v40/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "HarvestProjectType",
  "kind": "LinkedField",
  "name": "harvestProject",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "Unit4ProjectType",
  "kind": "LinkedField",
  "name": "unit4Project",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v5/*: any*/),
    (v41/*: any*/)
  ],
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "Client",
  "kind": "LinkedField",
  "name": "client",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customProjectId",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyTaskId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endDateString"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "fetchCustomFields"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "personId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startDateString"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "filters"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "company",
          "customFieldDefinitionsV2"
        ]
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": null
      },
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "timeRegistrations"
        ]
      }
    ]
  },
  "name": "TimesheetsPage_viewer",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "backendId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "language",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FeatureFlag",
      "kind": "LinkedField",
      "name": "availableFeatureFlags",
      "plural": true,
      "selections": [
        (v4/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": "filters",
      "args": null,
      "concreteType": "FilterTypeConnection",
      "kind": "LinkedField",
      "name": "__Viewer_filters_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FilterTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Filter",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v5/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "section",
                  "storageKey": null
                },
                (v6/*: any*/),
                (v7/*: any*/),
                (v8/*: any*/)
              ],
              "storageKey": null
            },
            (v9/*: any*/)
          ],
          "storageKey": null
        },
        (v10/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CalendarIntegrations",
      "kind": "LinkedField",
      "name": "calendarIntegrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CalendarIntegration",
          "kind": "LinkedField",
          "name": "googleCalendar",
          "plural": false,
          "selections": (v11/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CalendarIntegration",
          "kind": "LinkedField",
          "name": "outlookCalendar",
          "plural": false,
          "selections": (v11/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useTimeApproval",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useInternalTimeApproval",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useTimeOffApproval",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "harvestEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bambooHREnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hiBobEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sageIntacctEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unit4Enabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "characterLimit",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lockedPeriodYear",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lockedPeriodMonth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lockedPeriodDay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "includeDisabled",
              "value": false
            }
          ],
          "concreteType": "RoleTypeConnection",
          "kind": "LinkedField",
          "name": "roles",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoleTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Role",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v12/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "roles(includeDisabled:false)"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Module",
          "kind": "LinkedField",
          "name": "modules",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "moduleType",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "internalTimes",
          "args": [
            {
              "kind": "Literal",
              "name": "excludeDisabled",
              "value": true
            },
            (v13/*: any*/),
            {
              "kind": "Literal",
              "name": "internalTime",
              "value": true
            }
          ],
          "concreteType": "IdleTimeTypeConnection",
          "kind": "LinkedField",
          "name": "idleTimes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            }
          ],
          "storageKey": "idleTimes(excludeDisabled:true,first:100000,internalTime:true)"
        },
        {
          "alias": null,
          "args": [
            (v13/*: any*/)
          ],
          "concreteType": "IdleTimeTypeConnection",
          "kind": "LinkedField",
          "name": "idleTimes",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "IdleTimeTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IdleTime",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v15/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "idleTimes(first:100000)"
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "id",
              "variableName": "personId"
            }
          ],
          "concreteType": "Person",
          "kind": "LinkedField",
          "name": "person",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "HolidayCalendar",
              "kind": "LinkedField",
              "name": "holidayCalendar",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "first",
                      "value": 10000
                    }
                  ],
                  "concreteType": "HolidayCalendarEntryTypeConnection",
                  "kind": "LinkedField",
                  "name": "holidayCalendarEntries",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "HolidayCalendarEntryTypeEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "HolidayCalendarEntry",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            (v16/*: any*/),
                            (v17/*: any*/),
                            (v18/*: any*/),
                            (v5/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": "holidayCalendarEntries(first:10000)"
                },
                (v5/*: any*/)
              ],
              "storageKey": null
            },
            (v0/*: any*/),
            (v19/*: any*/),
            (v20/*: any*/),
            (v21/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fullName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "systemUser",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "initials",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "active",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "monday",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tuesday",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "wednesday",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "thursday",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "friday",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "saturday",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sunday",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "excludeFromCompanyLockedPeriod",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "submitLockedDateYear",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "submitLockedDateMonth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "submitLockedDateDay",
              "storageKey": null
            },
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "economicUser",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profilePictureId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profilePictureDefaultId",
              "storageKey": null
            },
            (v3/*: any*/)
          ],
          "storageKey": null
        },
        {
          "condition": "fetchCustomFields",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": "customFieldDefinitionsV2",
              "args": null,
              "concreteType": "CustomFieldDefinitionV2TypeConnection",
              "kind": "LinkedField",
              "name": "__Company_customFieldDefinitionsV2_connection",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CustomFieldDefinitionV2TypeEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v4/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "type",
                          "storageKey": null
                        },
                        (v22/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "entityType",
                          "storageKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": (v23/*: any*/),
                          "type": "TextCustomField",
                          "abstractKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": (v24/*: any*/),
                          "type": "DropdownCustomField",
                          "abstractKey": null
                        },
                        (v8/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v9/*: any*/)
                  ],
                  "storageKey": null
                },
                (v10/*: any*/)
              ],
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "excludeReadOnly",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "excludeRestricted",
          "value": true
        },
        (v13/*: any*/)
      ],
      "concreteType": "ProjectTypeConnection",
      "kind": "LinkedField",
      "name": "projects",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ProjectDropdown_projects"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v5/*: any*/),
                (v25/*: any*/),
                (v26/*: any*/),
                (v27/*: any*/),
                (v28/*: any*/),
                (v29/*: any*/),
                (v30/*: any*/),
                (v31/*: any*/),
                (v32/*: any*/),
                (v33/*: any*/),
                (v34/*: any*/),
                (v35/*: any*/),
                (v36/*: any*/),
                (v37/*: any*/),
                (v38/*: any*/),
                (v39/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "HarvestProjectType",
                  "kind": "LinkedField",
                  "name": "harvestProject",
                  "plural": false,
                  "selections": (v40/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Unit4ProjectType",
                  "kind": "LinkedField",
                  "name": "unit4Project",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v41/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isJiraProject",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "projects(excludeReadOnly:true,excludeRestricted:true,first:100000)"
    },
    {
      "alias": "timeRegistrations",
      "args": null,
      "concreteType": "TimeRegTypeConnection",
      "kind": "LinkedField",
      "name": "__Viewer_timeRegistrations_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeRegTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TimeRegType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v16/*: any*/),
                (v17/*: any*/),
                (v18/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "minutesRegistered",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "billableMinutesRegistered",
                  "storageKey": null
                },
                (v7/*: any*/),
                (v19/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "notes",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "invoiced",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "xeroInvoiceId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lockedInPeriod",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "harvestTimeId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "allocationId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "harvestTaskIdInt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "harvestError",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "unit4ActivityId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "approvalStatus",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hiBobAllocationId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProjectType",
                  "kind": "LinkedField",
                  "name": "project",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v5/*: any*/),
                    (v27/*: any*/),
                    (v29/*: any*/),
                    (v26/*: any*/),
                    (v42/*: any*/),
                    (v25/*: any*/),
                    (v43/*: any*/),
                    (v44/*: any*/),
                    (v45/*: any*/),
                    (v28/*: any*/),
                    (v30/*: any*/),
                    (v31/*: any*/),
                    (v32/*: any*/),
                    (v33/*: any*/),
                    (v34/*: any*/),
                    (v35/*: any*/),
                    (v36/*: any*/),
                    (v37/*: any*/),
                    (v38/*: any*/),
                    (v39/*: any*/),
                    (v46/*: any*/),
                    (v47/*: any*/),
                    (v48/*: any*/),
                    (v49/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Task",
                  "kind": "LinkedField",
                  "name": "task",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v5/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "progress",
                      "storageKey": null
                    },
                    (v50/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "jiraId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "highPriority",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "approved",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "timeLeft",
                      "storageKey": null
                    },
                    (v14/*: any*/),
                    (v25/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "latestUiUpdateAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "estimateForecastMinutes",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "totalMinutesRegistered",
                      "storageKey": null
                    },
                    (v28/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "parentTaskId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Task",
                      "kind": "LinkedField",
                      "name": "parentTask",
                      "plural": false,
                      "selections": [
                        (v5/*: any*/),
                        (v50/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startYear",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startMonth",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startDay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "deadlineYear",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "deadlineMonth",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "deadlineDay",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "StatusColumnV2",
                      "kind": "LinkedField",
                      "name": "statusColumnV2",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "category",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Person",
                      "kind": "LinkedField",
                      "name": "assignedPersons",
                      "plural": true,
                      "selections": (v40/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProjectType",
                      "kind": "LinkedField",
                      "name": "project",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v5/*: any*/),
                        (v27/*: any*/),
                        (v26/*: any*/),
                        (v43/*: any*/),
                        (v44/*: any*/),
                        (v45/*: any*/),
                        (v28/*: any*/),
                        (v29/*: any*/),
                        (v42/*: any*/),
                        (v25/*: any*/),
                        (v30/*: any*/),
                        (v31/*: any*/),
                        (v32/*: any*/),
                        (v33/*: any*/),
                        (v34/*: any*/),
                        (v35/*: any*/),
                        (v36/*: any*/),
                        (v37/*: any*/),
                        (v38/*: any*/),
                        (v39/*: any*/),
                        (v48/*: any*/),
                        (v46/*: any*/),
                        (v47/*: any*/),
                        (v49/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PhaseType",
                      "kind": "LinkedField",
                      "name": "phase",
                      "plural": false,
                      "selections": (v12/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IdleTime",
                  "kind": "LinkedField",
                  "name": "idleTime",
                  "plural": false,
                  "selections": (v15/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Person",
                  "kind": "LinkedField",
                  "name": "person",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v20/*: any*/),
                    (v21/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isViewer",
                      "storageKey": null
                    },
                    (v19/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": "customFields",
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "fetchCustomFields",
                      "variableName": "fetchCustomFields"
                    }
                  ],
                  "concreteType": "CustomFieldValueV2TypeConnection",
                  "kind": "LinkedField",
                  "name": "__TimeRegistrations_customFields_connection",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CustomFieldValueV2TypeEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v8/*: any*/),
                            (v4/*: any*/),
                            (v22/*: any*/),
                            (v6/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "displayValue",
                              "storageKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v23/*: any*/),
                              "type": "TextCustomFieldValue",
                              "abstractKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v24/*: any*/),
                              "type": "DropdownCustomFieldValue",
                              "abstractKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        (v9/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v10/*: any*/)
                  ],
                  "storageKey": null
                },
                (v8/*: any*/)
              ],
              "storageKey": null
            },
            (v9/*: any*/)
          ],
          "storageKey": null
        },
        (v10/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "7bf94c620db79b1c4e34d96dca015440";

export default node;
